import { dataelementAPI } from 'api/dataelement';
import { FindAllDataelementDto } from 'dto/dataelement';
import { useInfiniteQuery } from 'react-query';
import { defaultPageIndex, defaultCompactPageSize } from 'utils/constants';
import { QUERY_KEY } from 'utils/enums';

type PropsType = {
  filters: FindAllDataelementDto;
};

export function useFindAllDataelementCompact(props: PropsType) {
  const infiniteQuery = useInfiniteQuery({
    queryKey: [QUERY_KEY.FIND_ALL_DATAELEMENT_COMPACT, props.filters],
    queryFn: ({ pageParam = defaultPageIndex }) =>
      dataelementAPI.findAllCompact({
        ...props.filters,
        pageIndex: pageParam,
        pageSize: defaultCompactPageSize,
      }),
    getNextPageParam: (lastPage, allPages) => allPages.length + 1,
    cacheTime: 0,
  });

  return {
    infiniteQuery: infiniteQuery,
    count: infiniteQuery.data?.pages[0].count ?? 0,
    rows: infiniteQuery.data?.pages.flatMap((page) => page.rows) ?? [],
    loading:
      infiniteQuery.isLoading ||
      infiniteQuery.isFetching ||
      infiniteQuery.isRefetching,
  };
}
